import { Fab, Tooltip, Zoom } from '@mui/material';
import { WhatsApp } from '@mui/icons-material';
import { motion } from 'framer-motion';

const WhatsAppButton = () => {
  return (
    <Zoom in={true} style={{ transitionDelay: '500ms' }}>
      <Tooltip title="Message John on WhatsApp" placement="left">
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.3 }}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
        >
          <Fab
            href="https://wa.me/27720100332"
            target="_blank"
            sx={{
              position: 'fixed',
              bottom: 30,
              right: 30,
              background: '#25D366',
              color: '#fff',
              '&:hover': { background: '#128C7E' },
              zIndex: 1000,
            }}
          >
            <WhatsApp sx={{ fontSize: 30 }} />
          </Fab>
        </motion.div>
      </Tooltip>
    </Zoom>
  );
};

export default WhatsAppButton;